/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Azure subscription configuration. Applicable if `cloudProvider` is set to `AZURE`. 
*/
export class AzureRestoreAccountAttributes {
  /**
  * ID of the tenant the subscription belongs to.
  */
  'tenantId': string;
  /**
  * ID of the Azure subscription.
  */
  'subscriptionId': string;
  /**
  * Name of the Azure resource group to scope permissions to. When provided, restoring is limited to this specific resource group. When omitted, permissions are scoped to the subscription. 
  */
  'resourceGroupName'?: string;
  /**
  * Azure region for restore operations.
  */
  'location'?: string;
  /**
  * Name of the Eon internal resource group for temporary restore resources. 
  */
  'eonInternalResourceGroupName'?: string;
  /**
  * ID of the Azure management group the restore account is scoped to.
  */
  'managementGroupId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "eonInternalResourceGroupName",
      "baseName": "eonInternalResourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementGroupId",
      "baseName": "managementGroupId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureRestoreAccountAttributes.attributeTypeMap;
  }

  public constructor() {
  }
}

